<template>
  <div class="teacher-search">
    <van-nav-bar title="园区师资查询" left-arrow @click-left="$router.back()" />

    <van-search
      v-model="searchQuery.name"
      placeholder="输入教师姓名查询"
      @search="onSearch"
      @cancel="onCancel"
    />
    <van-divider
      :style="{
        color: '#666',
        borderColor: '#ddd',
        padding: '0 0',
        fontSize: '16px',
      }"
    >
      {{ searchQuery.recommend === 1 ? "推荐教师" : "搜索结果" }}
    </van-divider>
    <van-skeleton
      title
      :row="3"
      :loading="loading"
      style="margin-top: 40px"
    >
      <div v-if="teachers.length" class="teacher-list">
        <div
          v-for="(teacher, index) in teachers"
          :key="index"
          class="custom-card"
          @click="goToTeacherDetail(teacher.id)"
        >
          <!-- <img :src="teacher.avatar" class="avatar" /> -->
          <van-image :src="teacher.avatar" class="avatar" radius="5%" />
          <div class="card-info">
            <p class="name">{{ teacher.name }}</p>
            <p class="major">专业：{{ teacher.major }}</p>
            <p class="admission">入园时间：{{ teacher.admissiontime }}</p>
          </div>
        </div>
        <van-pagination
          v-model="pagination.current"
          :total-items="pagination.total"
          :items-per-page="pagination.perpage"
          :page-count="pagination.pagecount"
          @change="onPageChange"
        />
      </div>

      <van-empty v-if="teachers.length === 0" description="暂无教师" />
    </van-skeleton>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "TeacherSearch",
  data() {
    return {
      loading: true, // 控制加载状态
      searchQuery: {
        page: 1,
        limit: 10,
        recommend: 1,
        name: "",
      },
      pagination: {
        current: 1,
        total: 0,
        perpage: 10,
        pagecount: 0,
      },
      teachers: [],
    };
  },
  methods: {
    async onSearch() {
      this.loading = true; // 设置加载状态为true
      if (this.searchQuery.name === "") {
        this.searchQuery = {
          page: 1,
          limit: 10,
          recommend: 1,
          name: "",
        };
      } else {
        this.searchQuery.recommend = 0;
        this.searchQuery.keyword = this.searchQuery.name;
      }
      await this.fetchTeachers();
    },
    async onCancel() {
      this.loading = true; // 设置加载状态为true
      this.searchQuery = {
        page: 1,
        limit: 10,
        recommend: 1,
        name: "",
      };
      await this.fetchTeachers();
    },

    async fetchTeachers() {
      console.log("searchQuery", this.searchQuery);
      try {
        const res = await api.searchTeachers(this.searchQuery);
        console.log("teachers res", res);
        if (res.data.data && res.data.success) {
          this.teachers = res.data.data.list;
          this.pagination.total = res.data.data.count;
          this.pagination.pagecount = res.data.data.totalpage;
          this.pagination.current = this.searchQuery.page;
          if (res.data.data.count === 0) {
            this.$toast.fail("未找到相关教师");
          } else if (res.data.data.count === 1) {
            this.goToTeacherDetail(this.teachers[0].id);
          }
        } else {
          this.$toast.fail("未找到相关教师");
        }
      } catch (err) {
        this.$toast.fail("查询失败，请稍后重试");
      } finally {
        this.loading = false; // 设置加载状态为false
      }
    },

    async onPageChange(page) {
      console.log("page change", page);
      this.searchQuery.page = page;
      this.loading = true; // 设置加载状态为true
      await this.fetchTeachers();
    },
    goToTeacherDetail(id) {
      console.log("id", id);
      this.$router.push({ path: `/teacherdetail/${id}` });
    },
  },
  mounted() {
    this.fetchTeachers();
  },
};
</script>

<style scoped>
.teacher-search {
  padding: 20px;
  margin-bottom: 20px;
}
.teacher-list {
  margin-bottom: 30px;
}
.avatar {
  width: 66px;
  height: 100px;
  border-radius: 50%;
  margin-right: 20px;
}
.custom-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  cursor: pointer;
  /* border: 1px solid #666; */
}
.card-info {
  flex-grow: 1;
}
.name {
  font-weight: bold;
  font-size: 16px;
}
.major,
.admission {
  color: #666;
}
</style>
